module.exports = __webpack_public_path__ + "static/media/javea-16.7da53df5.jpg";